module.exports = __webpack_public_path__ + "static/media/waypoint_p.b1482054.svg";